import { COLOR_OPTIONS } from 'config/style';
import { createGlobalStyle } from 'styled-components';

export const DigitalTrapsMapStyles = createGlobalStyle`
  .trap-popup {
    .mapboxgl-popup-content {
      padding: 12px;
      border-radius: 4px;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
      width: 300px;
      transform: translateX(-50%);
    }

    .mapboxgl-popup-tip {
      border-top-color: white;
      border-bottom-color: white;
    }

    .trap-popup-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      gap: 10px;
      align-self: stretch;
      background: ${COLOR_OPTIONS.NEUTRAL_00};
      font-family: 'Noto Sans', sans-serif;
      min-width: 180px;
      color: ${COLOR_OPTIONS.NEUTRAL_100};
    }

    .trap-popup-header {
      width: 100%;
    }

    .trap-popup-name {
      font-size: 14px;
      font-weight: 600;
      line-height: 20px;
      letter-spacing: -0.105px;
      color: ${COLOR_OPTIONS.NEUTRAL_100};
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .trap-popup-id {
      font-size: 12px;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: -0.09px;
      color: ${COLOR_OPTIONS.NEUTRAL_60};
    }

    .trap-popup-description {
      display: flex;
      width: 100%;
    }

    .trap-popup-description-group {
      display: flex;
      align-items: center;
      overflow: hidden;

      &.pest-label {
        max-width: 60%;
      }

      &.crop {
        margin-left: 16px;
        max-width: 40%;
      }
    }

    .trap-popup-description-icon {
      display: flex;
      margin-right: 4px;
      font-size: 16px;
      flex-shrink: 0;
      color: ${COLOR_OPTIONS.NEUTRAL_60};
    }

    .trap-popup-description-text {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      flex: 1;
      color: ${COLOR_OPTIONS.NEUTRAL_60};
    }

    .trap-popup-pest-pressure {
      display: flex;
      column-gap: 8px;
    }

    .trap-popup-pest-pressure-label {
      font-size: 14px;
    }

    .trap-popup-tag {
      display: flex;
      align-items: center;
      padding: 0 4px;
      font-size: 12px;
      font-weight: 600;
      gap: 4px;
      border-radius: 2px;

      &.risk-low {
        background-color: ${COLOR_OPTIONS.GREEN_20};
        color: ${COLOR_OPTIONS.GREEN_70};
      }

      &.risk-medium {
        background-color: ${COLOR_OPTIONS.YELLOW_20};
        color: ${COLOR_OPTIONS.YELLOW_70};
      }

      &.risk-high {
        background-color: ${COLOR_OPTIONS.RED_20};
        color: ${COLOR_OPTIONS.RED_70};
      }

      &.risk-default {
        background-color: ${COLOR_OPTIONS.NEUTRAL_20};
        color: ${COLOR_OPTIONS.NEUTRAL_60};
      }

      &.risk-not_applicable, &.risk-no_threshold {
        background-color: ${COLOR_OPTIONS.NEUTRAL_20};
        color: ${COLOR_OPTIONS.NEUTRAL_70};
      }
    }
  }

  .cluster-popup {
    .mapboxgl-popup-content {
      transform: translateX(-50%);
      left: 50%;

      .cluster-popup-container {
        width: max-content;
        display: flex;
        flex-direction: column;
        gap: 10px;
        padding: 10px;
        border-radius: 4px;

        .cluster-popup-count {
          font-family: 'Noto Sans', sans-serif;
          color: ${COLOR_OPTIONS.NEUTRAL_100};
          font-size: 16px;
          font-weight: 600;
          line-height: 20px;
          letter-spacing: -0.105px;
        }

        .cluster-popup-content {
          display: flex;
          flex-direction: column;
          gap: 2px;

          .cluster-popup-pest-pressure-label {
            font-family: 'Noto Sans', sans-serif;
            color: ${COLOR_OPTIONS.NEUTRAL_60};
            font-size: 14px;
            line-height: 20px;
          }

          .cluster-popup-pest-pressure-value {
            font-family: 'Noto Sans', sans-serif;
            color: ${COLOR_OPTIONS.NEUTRAL_100};
            font-size: 14px;
            line-height: 20px;

            .risk {
              font-weight: 600;

              &.low {
                color: ${COLOR_OPTIONS.GREEN_70};
              }

              &.medium {
                color: ${COLOR_OPTIONS.YELLOW_70};
              }

              &.high {
                color: ${COLOR_OPTIONS.RED_70};
              }

              &.not_applicable {
                color: ${COLOR_OPTIONS.NEUTRAL_70};
              }
            }

          }
        }
      }
    }
  }
`;
